/**
 * Gender-based default avatar URLs (no generic default).
 * Missing / unknown gender → male default (safety fallback).
 */
export function defaultAvatarByGender(gender) {
  const g = String(gender || "").trim().toLowerCase();
  if (g === "female") return "/images/default-female.png";
  return "/images/default-male.png";
}
